<div class="no-results-wrapper">
  <div class="no-results-image">
    <img src="assets/icons/search-result.svg" />
  </div>
  <div class="d-flex flex-column no-results-text">
    <app-text class="h4-strong text-c100" style="margin-top: 16px;">No results found.</app-text>
    <app-text class="light-body-m text-c100">We could not find any match results you are searching for.</app-text>
  </div>
</div>